import {create} from 'zustand';

interface ShareRegistrationLinkStore {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useShareRegistrationLinkStore = create<ShareRegistrationLinkStore>(set => ({
  isModalOpen: false,

  openModal: () => set({isModalOpen: true}),
  closeModal: () => set({isModalOpen: false}),
}));
